import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'billingFrequency'
})
export class BillingFrequencyPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value == 1) {
      return 'monthly';
    } else if (value == 2) {
      return 'annually';
    }
  }

}
